import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aed645e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app pt-10" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-5xl w-full text-center" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Vue.js OpenAI API Playground")
], -1))
const _hoisted_3 = { class: "main container mx-auto mt-6 pl-1 pb-3" }
const _hoisted_4 = { class: "description container mx-auto mt-8 pr-2 text-xl" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = ["href"]
const _hoisted_7 = ["href"]
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "mt-4" }
const _hoisted_10 = {
  key: 2,
  class: "tokens-left text-xs"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Tokens count (approximate): ", -1))
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 5,
  class: "image-wrapper",
  ref: "result"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Result:", -1))
const _hoisted_16 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_APIKey = _resolveComponent("APIKey")!
  const _component_OpenAITextSettings = _resolveComponent("OpenAITextSettings")!
  const _component_Accordeon = _resolveComponent("Accordeon")!
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_InputFile = _resolveComponent("InputFile")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputTextarea = _resolveComponent("InputTextarea")!
  const _component_Error = _resolveComponent("Error")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createTextVNode(" An example project based on Vue CLI to demonstrate basic OpenAI GPT possibilities."),
        _hoisted_5,
        _createTextVNode(" Create your own Chat GPT! "),
        _createElementVNode("div", null, [
          _createElementVNode("a", {
            class: "text-base",
            target: "_blank",
            href: _ctx.currentGuide
          }, "OpenAI API Guide", 8, _hoisted_6)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("a", {
            class: "text-base",
            target: "_blank",
            href: 'https://github.com/Kypaku/vue-gpt-playground'
          }, "GitHub Project", 8, _hoisted_7)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("a", {
            class: "text-base",
            target: "_blank",
            href: 'https://www.npmjs.com/package/gpt-simple-api-ts'
          }, "API", 8, _hoisted_8)
        ])
      ]),
      _createVNode(_component_APIKey, {
        value: _ctx.apiKey,
        "onUpdate:value": [
          _cache[0] || (_cache[0] = ($event: any) => ((_ctx.apiKey) = $event)),
          _cache[1] || (_cache[1] = (val) => _ctx.updateApiKey(val))
        ]
      }, null, 8, ["value"]),
      _createVNode(_component_Accordeon, {
        title: "Settings",
        value: _ctx.settings,
        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.settings) = $event)),
        class: "mt-3 api-key"
      }, {
        default: _withCtx(() => [
          (_ctx.settings)
            ? (_openBlock(), _createBlock(_component_OpenAITextSettings, {
                key: 0,
                value: _ctx.textOpts,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.textOpts) = $event)),
                models: _ctx.models
              }, null, 8, ["value", "models"]))
            : _createCommentVNode("", true),
          (_ctx.settings)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "save-button",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.saveSettings && _ctx.saveSettings(...args)))
              }, _toDisplayString(_ctx.savedSettings ? "Saved!" : "Save"), 1))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["value"]),
      _createVNode(_component_Tabs, {
        value: _ctx.tab,
        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.tab) = $event)),
        tabs: _ctx.tabs,
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.clearResult())),
        class: "mt-10 w-full"
      }, null, 8, ["value", "tabs"]),
      (_ctx.tab === 'audio')
        ? (_openBlock(), _createBlock(_component_InputFile, {
            key: 0,
            class: "mt-4",
            accept: ['.m4a', '.mp3', '.webm', '.mp4', '.mpga', '.wav', '.mpeg'],
            value: _ctx.audioFile,
            "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.audioFile) = $event))
          }, null, 8, ["accept", "value"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        (_ctx.tab === 'audio')
          ? (_openBlock(), _createBlock(_component_InputText, {
              key: 0,
              value: _ctx.whisperLanguage,
              "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.whisperLanguage) = $event)),
              class: "language-input",
              placeholder: 'empty for auto',
              suggestions: _ctx.langCodes,
              label: "Input language (code):"
            }, null, 8, ["value", "suggestions"]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.tab !== 'audio')
        ? (_openBlock(), _createBlock(_component_InputTextarea, {
            key: 1,
            showSpeechRecording: _ctx.showSpeechRecording,
            apiKeyNeeded: _ctx.apiKeyNeeded,
            isLoading: "",
            value: _ctx.prompt,
            "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.prompt) = $event)),
            onSetPromt: _cache[10] || (_cache[10] = (val) => _ctx.$emit('update:value', val)),
            label: 'Prompt:',
            class: "w-full rounded-lg mt-8",
            rows: 10
          }, null, 8, ["showSpeechRecording", "apiKeyNeeded", "value"]))
        : _createCommentVNode("", true),
      (!_ctx.tab)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("span", null, _toDisplayString(_ctx.tokensCount), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.tab === 'audio')
        ? (_openBlock(), _createElementBlock("button", {
            key: 3,
            disabled: _ctx.isTranscribing || !_ctx.audioFile,
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.runTranscribe(_ctx.audioFile))),
            class: "mt-2 bg-gray-300 run-btn px-8 py-2 text-white rounded"
          }, [
            _createElementVNode("b", null, _toDisplayString(_ctx.isLoading ?  "Loading..." : "Run"), 1)
          ], 8, _hoisted_12))
        : (_openBlock(), _createElementBlock("button", {
            key: 4,
            disabled: _ctx.tab === 'image' ? _ctx.isLoading : (!_ctx.textOpts.stream && _ctx.isLoading),
            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.run())),
            class: "mt-2 bg-gray-300 run-btn px-8 py-2 text-white rounded"
          }, [
            _createElementVNode("b", null, _toDisplayString(_ctx.isLoading ? (_ctx.tab === 'image' || !_ctx.textOpts.stream ? "Loading..." : 'Stop') : "Run"), 1)
          ], 8, _hoisted_13)),
      (_ctx.tab === 'image' && _ctx.result)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("img", {
              src: _ctx.result,
              alt: "result"
            }, null, 8, _hoisted_16)
          ], 512))
        : (_ctx.result)
          ? (_openBlock(), _createBlock(_component_InputTextarea, {
              key: 6,
              value: _ctx.result,
              "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.result) = $event)),
              label: 'Result:',
              disabled: "",
              class: "mt-8",
              rows: 10,
              ref: "result"
            }, null, 8, ["value"]))
          : _createCommentVNode("", true),
      (_ctx.error)
        ? (_openBlock(), _createBlock(_component_Error, {
            key: 7,
            value: _ctx.error,
            class: "mt-2"
          }, null, 8, ["value"]))
        : _createCommentVNode("", true)
    ])
  ]))
}